'use client'
import type { ReactNode } from 'react'
import { type State, WagmiProvider } from 'wagmi'
import { wagmiConfig } from '@/src/ecosystems/evm/config'

interface EvmProviderProps {
  children: ReactNode
  initialState?: State
}

export function EvmProvider({ children, initialState }: EvmProviderProps) {
  return (
    <WagmiProvider config={wagmiConfig} initialState={initialState}>
      {children}
    </WagmiProvider>
  )
}
